import { Router, ActivatedRoute } from '@angular/router';
import {
  ViewEncapsulation,
  Component,
  OnInit,
  ViewChild,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { ISupplierInvoice } from '../../interfaces/supplier-invoice';
import { ITransactionLine } from '../../interfaces/transaction-line';
import { SupplierInvoiceService } from '../../services/supplier-invoice.service';
import { TransactionLinesService } from '../../services/transaction-lines.service';

@Component({
  selector: 'supplier-invoice-view',
  templateUrl: './supplier-invoice-view.component.html',
  styleUrls: ['./supplier-invoice-view.component.scss'],
  encapsulation: ViewEncapsulation.None, // todo: double check
})
export class SupplierInvoiceViewComponent implements OnInit {
  invoice: ISupplierInvoice;
  engineius: any;
  totals: any;
  tlines: ITransactionLine[];
  initiated: boolean;

  private _invoiceId: number;
  @Input('invoiceId')
  set invoiceId(value: number) {
    this._invoiceId = value;

    if (this.initiated) {
      this.load();
    }
  }
  get invoiceId(): number {
    return this._invoiceId;
  }

  @Output() onHide: EventEmitter<any>;

  constructor(
    private supplierInvoiceService: SupplierInvoiceService,
    private router: Router,
    private route: ActivatedRoute,
    private transactionLinesService: TransactionLinesService,
  ) {
    this.onHide = new EventEmitter<any>();
  }

  ngOnInit() {
    //for a separate page view case (if we remove the page, then delete this line)
    if (!this.invoiceId) this.invoiceId = this.route.snapshot.params['id'];

    this.load();

    this.initiated = true;
  }

  load() {
    this.supplierInvoiceService.get(this.invoiceId).then((res) => {
      this.invoice = res;
    });

    this.transactionLinesService.getSupplierInvoiceTransactions(this.invoiceId).then((result) => {
      this.tlines = result;
    });

    this.supplierInvoiceService.getEngineiusDetailsForInvoice().then((res) => {
      this.engineius = res;
    });
  }

  print() {
    window.print();
  }

  hide() {
    this.onHide.emit();
  }
}
